import { isTextNode } from 'anodum';

const isTextNodeWithSpacingOnly = (node) =>
  isTextNode(node) && node.nodeValue.length > 0 && node.nodeValue.trim().length === 0;

export default isTextNodeWithSpacingOnly;
